/**
 * Shared confirmation gate for destructive delete / remove / clear actions.
 *
 * Usage:
 *   if (!confirmDelete('the "Foo" rule')) return;                       // single confirm
 *   if (!confirmDelete(name, { strong: true })) return;                 // type-to-confirm
 *   if (!confirmDelete('all overrides', { detail: 'Wipes …' })) return; // custom detail
 *
 * @param {string} label   What is being deleted (shown in the dialog).
 * @param {object} [opts]
 * @param {boolean} [opts.strong]  Require the user to type `label` exactly to proceed.
 * @param {string}  [opts.detail]  Extra line explaining the consequence.
 * @returns {boolean} true if the user confirmed, false if cancelled.
 */
export function confirmDelete(label, opts = {}) {
  const { strong = false, detail = 'This action cannot be undone.' } = opts;

  if (!window.confirm(`Delete ${label}?\n\n${detail}`)) return false;

  if (strong) {
    const typed = window.prompt(`To confirm, type the name exactly:\n\n${label}`);
    if (typed === null) return false;                       // cancelled
    if (typed.trim() !== String(label)) {
      window.alert('Name did not match — deletion cancelled.');
      return false;
    }
  }
  return true;
}
